import React from 'react'
import { Alert } from 'components'
import { useMediaQuery } from '@mui/material';
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { alerts } from 'keys'
import { bg } from 'styles/theme'
import AffiliationSetup from '.'

const AffiliationSetupAlert = (props) => {
    const dispatch = useDispatch()
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('xl'), { noSsr: true })

    const handleAlert = (val) => {
        dispatch(actions.setAlerts({ key: alerts.schoolSetup, value: { open: val, props: null } }))
    }

    return (
        <Alert
            bg={bg}
            size={{
                width: isSmallScreen ? 800 : 1200,
                height: isSmallScreen ? 450 : 700
            }}
            systemUI
            title={""}
            footerActions={[]}
            handleAlert={handleAlert}
            closeOnClick
        >
            <AffiliationSetup />
        </Alert>
    )
}

export default AffiliationSetupAlert